<template>
  <div class="trivia-question-container">
    <Timer time="20" :key="this.$store.state.currentCategory"/>
    <Category :category="this.$store.state.currentCategory" />
    <div class="trivia-question">
      <h1 class="question">{{ questions[0].question }}</h1>
      <ul class="answer-container">
        <li v-for="(value, index) in answers" :key="index">
          <Answer :key="index" :answerId="keys[index]" :answerText="value"  @click.native="checkAnswer" />
        </li>
      </ul>
      <Button v-if="buttonText == 'Skip'" :key="this.path" :color="this.color" :buttonText="this.buttonText" @click.native.prevent="clickSkip" />
      <Button v-if="buttonText == 'Next'" :key="this.path" :color="this.color" :buttonText="this.buttonText" @click.native.prevent="clickNext" />
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
// const Button = () => import('@/components/Button.vue')
import Category from '@/components/Category.vue'
// const Category = () => import('@/components/Category.vue')
import Timer from '@/components/Timer.vue'
// const Timer = () => import('@/components/Timer.vue')
import Answer from '@/components/Answer.vue'
// const Answer = () => import('@/components/Answer.vue')
import eventBus from '@/eventBus'

export default {
  name: 'triviaQuestion',
  components: {
    Button,
    Category,
    Timer,
    Answer
  },
  data() {
    return {
      questions: [],
      buttonText: "Skip",
      color: "",
      path: "",
      answers: [],
      correctAnswer: "",
      keys: ["A", "B", "C", "D"],
    }
  },
  methods: {
    shuffle(array) {
      let currentIndex = array.length;
      let temporaryValue, randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array
    },
    setDefaults() {
      this.questions = this.shuffle(this.$store.getters.trivia)
      this.answers = this.questions[0].answers.split('; ')
      this.correctAnswer = this.questions[0].correctAnswer
    },

    clickSkip() {
      this.questions = this.questions.concat(this.questions.splice(0, 1));
      this.answers = this.questions[0].answers.split('; ')
      this.correctAnswer = this.questions[0].correctAnswer
      this.$store.dispatch('subtractSkipPoints')
    },

    clickNext() {
      this.questions.shift()
      if(this.questions.length > 0) {
        this.answers = this.questions[0].answers.split('; ')
        this.correctAnswer = this.questions[0].correctAnswer
      } else {
        let cats = this.$store.state.categories
        let currentCat = this.$store.state.currentCategory
        let i = cats.indexOf(currentCat)

        if(i < cats.length - 1) {
          eventBus.$emit("reset-timer")
          this.$store.dispatch('updateCategory', cats[i + 1])
          this.setDefaults()
          this.$router.push({ path: '/trivia/category'})
        } else {
          eventBus.$emit("reset-timer")
          this.$router.push({ path: '/times-up', query: { fromTrivia: true, game: "1" }})
        }
      }

      this.buttonText = "Skip"
      this.color = ""

      let answers = document.querySelectorAll('.answer')
      let answerContainers = document.querySelectorAll('.answer-container li')

      answers.forEach((answer) => {
        answer.classList.remove('correct', 'incorrect')
        answer.style.pointerEvents = 'all'
      })

      answerContainers.forEach((answerContainer) => {
        answerContainer.classList.remove('correct', 'incorrect')
      })
    },

    checkAnswer: function(e) {
      let answers = document.querySelectorAll('.answer')
      if(e.target.dataset.answer == this.correctAnswer) {
        e.target.classList.add('correct')
        e.target.parentNode.classList.add('correct')
        answers.forEach((answer) => {
          answer.style.pointerEvents = 'none';
        })

        this.color = "orange"
        this.buttonText = "Next"
        this.$store.dispatch('addPoints')
      } else {
        let correct = document.querySelector(`[data-answer="${this.correctAnswer}"]`)
        correct.classList.add('correct')
        correct.parentNode.classList.add('correct')
        e.target.classList.add('incorrect')
        e.target.parentNode.classList.add('incorrect')
        answers.forEach((answer) => {
          answer.style.pointerEvents = 'none';
        })

        this.color = "orange"
        this.buttonText = "Next"
        this.$store.dispatch('subtractPoints')
      }
    }
  },
  beforeMount() {
    eventBus.$emit("reset-timer")
  },
  beforeDestroy() {
    eventBus.$off("timer-done");
  },
  mounted() {
    this.$ga.page('/trivia/questions')
    this.setDefaults()

    eventBus.$on('timer-done', () => {
      // eslint-disable-next-line no-console
      if(this.$route.name == 'triviaQuestion') {
        let cats = this.$store.state.categories
        let currentCat = this.$store.state.currentCategory
        let i = cats.indexOf(currentCat)

        if(i < cats.length - 1) {
          this.$store.dispatch('updateCategory', cats[i + 1])
          this.setDefaults()
          this.$router.push({ path: '/trivia/category'})
        } else {
          eventBus.$emit("reset-timer")
          this.$router.push({ path: '/times-up', query: { fromTrivia: true, game: "1" }})
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .trivia-question {
    left: 50%;
    position: absolute;
    top: 200px;
    transform: translateX(-50%);
    width: 960px;
  }

  .question {
    color: #fff;
    font-size: 42px;
  }

  .answer-container {
    background: rgba(0, 0, 0, 0.259);
    display: grid;
    grid-template-columns: 50% 50%;
    margin: 70px auto;
    padding: 5px;
    width: 100%;

    li {
      list-style-type: none;
      padding: 5px;

      &.correct {
        background: #fff;
      }
    }
  }
</style>